module.exports = (__webpack_require__(11))(13);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/react-dom/index.js from dll-reference vendor_lib
// module id = 71
// module chunks = 0